import styled from 'styled-components';
import {
  HelpBlock,
  ControlLabel as RsuiteControlLabel,
  FormGroup as RsuiteFormGroup,
  SelectPicker as RsuiteSelect
} from 'rsuite';

export const ControlLabel = styled(RsuiteControlLabel)`
  display: block;
  text-align: left;
  font-size: 14px;
  font-weight: normal;
  white-space: normal;
  text-transform: none;
`;

export const FormGroup = styled(RsuiteFormGroup)`
  margin-bottom: 10px !important;
`;

export const SelectPicker = styled(RsuiteSelect)`
  width: 300px;
  .rs-picker-default .rs-picker-toggle {
    position: initial;
  }
`;

export const CompressFormGroup = styled(FormGroup)`
  margin-bottom: 5px !important;
  .rs-form-control-wrapper.read-only input {
    border: none;
  }
  .rs-form-control-wrapper > .rs-radio-group {
    padding-right: 10px;
  }
  &.error > .rs-control-label {
    color: #f44336;
  }
  &.error > .rs-form-control-wrapper > input,
  &.error > .rs-form-control-wrapper > .rs-picker-date,
  &.error > .rs-form-control-wrapper > .rs-radio-group,
  &.error > .rs-form-control-wrapper > .rs-picker-select,
  &.error > .rs-form-control-wrapper > .rs-panel,
  &.error > .rs-form-control-wrapper > .rs-checkbox-group {
    border-radius: 6px;
    border: 2px solid #f44336;
  }
  &.error > .rs-form-control-wrapper > .rs-radio-group-inline {
    margin-left: 0;
    > .rs-radio-inline {
      margin-left: 0;
    }
  }
`;

export const InlineFormGroup = styled(FormGroup)`
  vertical-align: top;
  display: inline-block !important;
  margin-right: 15px !important;
`;

export const InlineHelpBlock = styled(HelpBlock)`
  display: inline !important;
`;
